'use client';

import { ChevronRightIcon } from '@heroicons/react/solid';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

import { AdvFeature } from './AdvFeature';
import { Frequentlyuseddocs } from './Freq-used-docs';
import { SchDistFAQs } from './SchDistFAQs';
import { Schooldistrictfeatures } from './Schooldistrictfeatures';

// const districtImage = [
//   {
//     imagePath: '/images/schooldistrict/district-2x.png',
//     imageWidth: 1024,
//     alt: 'Boost compliance with digital workflows',
//   },
// ];

function Heading() {
  return (
    <div className="mx-auto w-[min(400px,100%)] md:mx-0 lg:w-[92%]">
      <h1 className="text-[34px] font-medium !leading-tight text-[#3D3E40] md:mr-4 md:text-3xl xl:text-[54px]">
        IEP Goal Tracking for Your Special Ed Department
      </h1>

      <p className="mb-2 mt-4 text-[17px] text-[#616366] md:mr-8 md:text-[18px] ">
        Ease the burden of paperwork on providers, and enhance compliance by
        leveraging the power of digital data
      </p>
    </div>
  );
}

function Demo() {
  return (
    <div className="flex flex-col items-center justify-center md:items-start">
      <div className="flex xl:w-[70%]">
        <Link
          href="/request-quote"
          className={
            'mr-2 mt-2 flex cursor-pointer items-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] bg-[#318ae5] p-3 text-base font-medium text-white hover:text-white md:py-2'
          }
        >
          Get a quote <ChevronRightIcon className="h-5 w-5" />
        </Link>
        <Link
          href="/schedule-demo"
          className={
            'mt-2 flex cursor-pointer items-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] p-3 text-base font-medium text-[#318AE5] md:py-2'
          }
        >
          Schedule a Demo
        </Link>
      </div>
      <div className="mt-2 flex  text-[#616366] ">
        or
        <Link href="/contact-us" className="mx-1 font-semibold text-[#318ae5] ">
          Contact us
        </Link>
        for more information.
      </div>
    </div>
  );
}

function TextViews() {
  return (
    <div className="flex flex-col gap-y-4">
      <Heading />
      <Demo />
    </div>
  );
}

function Topportion() {
  return (
    <section className="container  mx-auto mt-28 flex w-[90%] flex-col items-center justify-center overflow-hidden text-center md:flex-row  md:gap-x-4 md:p-6 md:px-0 md:py-4 md:text-left lg:justify-between lg:gap-x-0 lg:px-10 2xl:px-[10rem]">
      <div className="order-2 md:order-1">
        <TextViews />
      </div>
      <div className="order-1 mb-4 ml-0 mt-0 w-[min(70%,300px)] md:order-2 md:mx-auto md:mb-0 md:w-[80%] md:px-0 lg:w-full lg:px-4">
        {/* <OptimisedImage
          data={districtImage}
          defaultImagePath="/images/schooldistrict/district-1x.png"
          /> */}
        <Image
          src="/images/schooldistrict/district-2x.png"
          width={1024}
          height={1024}
          alt="Boost compliance with digital workflows"
        />
      </div>
    </section>
  );
}

function Compliant() {
  return (
    <div>
      <div className="m-auto flex items-center justify-center">
        <div className="mx-3 w-[30%] md:mx-0 md:w-[25%] lg:mx-3 lg:w-[15%] xl:mx-5 xl:w-[10%]">
          {/* <OptimisedImage
            defaultImagePath="/images/icons/compliant/Hippa/hippa-1x.png"
            data={[
              {
                imagePath: '/images/icons/compliant/Hippa/hippa-2x.png',
                imageWidth: 1024,
                alt: 'HIPAA',
              },
            ]}
          /> */}
          <Image
            src="/images/icons/compliant/Hippa/hippa-2x.png"
            width={1024}
            height={1024}
            alt="HIPAA"
          />
        </div>
        <div className="mx-3 w-[30%] md:mx-0 md:w-[25%] lg:mx-3 lg:w-[15%] xl:mx-5 xl:w-[10%]">
          {/* <OptimisedImage
            defaultImagePath="/images/icons/compliant/Ferpa/ferpa-1x.png"
            data={[
              {
                imagePath: '/images/icons/compliant/Ferpa/ferpa-2x.png',
                imageWidth: 1024,
                alt: 'FERPA',
              },
            ]}
          /> */}
          <Image
            src="/images/icons/compliant/Ferpa/ferpa-2x.png"
            width={1024}
            height={1024}
            alt="FERPA"
          />
        </div>
      </div>
      <div className="mt-4 flex flex-col items-center justify-center text-center">
        <h3 className="mb-2 w-[70%] text-[28px] font-[500] text-[#3d3e40] md:text-[36px] ">
          Data Privacy You Can Count On
        </h3>
        <p className="mb-4 w-[87%] text-[17px] text-[#616366] md:mx-60 md:text-[18px] xl:w-[58%]">
          AbleSpace prioritizes the privacy and security of student data and
          complies with various regulations, including HIPAA, FERPA, and
          statewide regulations like NYS Ed Law 2-D, ensuring that your
          sensitive information is always protected. Our platform is designed
          with multiple layers of security, including state-of-the-art
          encryption techniques, strict access controls, and regular audits and
          assessments to ensure that we are continuously meeting regulatory
          requirements.
        </p>
      </div>
      <div className="mb-6 flex justify-center">
        <Link
          href="/hipaa-ferpa-compliance"
          className={
            'mr-2 mt-2 flex cursor-pointer items-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] bg-[#318ae5] px-5 py-3 text-base font-medium text-white hover:text-white md:py-2'
          }
        >
          Learn more...
        </Link>
        <Link
          href="/request-quote"
          className={
            'mt-2 flex cursor-pointer items-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] p-3 text-base font-medium text-[#318AE5] md:py-2'
          }
        >
          Get a quote
          <ChevronRightIcon className="h-5 w-5" />
        </Link>
      </div>
    </div>
  );
}
export const Schoolanddistrict = () => {
  return (
    <div>
      <Topportion />
      <AdvFeature />
      <Compliant />
      <Schooldistrictfeatures />
      <Frequentlyuseddocs />
      <SchDistFAQs tag={'schools/districts'} />
    </div>
  );
};
